// event-bus.js
import observable from '@riotjs/observable';

const eventBus = {};
observable(eventBus);

export default eventBus;
